import { useLayoutEffect } from "react";

import { useSearchParams } from "react-router-dom";

import { toast } from "@app/common/hooks/useToasts";
import type { Integration } from "@app/common/types";

/**
 * Simple hook that will show a success/error toast based on the integration connection redirect query params.
 * */
const useConnectIntegrationToasts = ({
  integration,
  targetAction,
}: {
  integration?: Integration;
  targetAction: string;
}) => {
  const [queryParams] = useSearchParams();
  const action = queryParams.get("action");
  const isSuccess = queryParams.get("success") === "true";

  useLayoutEffect(() => {
    if (action !== targetAction || !integration) return;

    const displayName = integration.displayNameShort;

    if (isSuccess) {
      toast.success(`${displayName} connected successfully!`);
    } else {
      toast.error(
        `There was an error connecting ${displayName}. Please try again or contact support@read.ai if the problem persists.`
      );
    }
  }, [action, isSuccess]);
};

export default useConnectIntegrationToasts;
